/*eslint no-script-url: 0 */
import React, { Component } from "react";

class MatViewSelection extends Component {

	constructor(props) {
		super(props);
		this.state = {
			selectValues: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 8.0, 8.5, 9.0, 9.5, 10.0, 10.5, 11.0 , 11.5, 12.0, 12.5, 13.0, 13.5, 14.0, 14.5, 15.0, 15.5, 16.0, 16.5, 17.0, 17.5, 18.0, 18.5, 19.0, 19.5, 20.0]
		}
		this.topHandleChange = this.topHandleChange.bind(this);
		this.middleHandleChange = this.middleHandleChange.bind(this);
		this.bottomHandleChange = this.bottomHandleChange.bind(this);
	}

	topHandleChange(event) {
    	this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedTopMatValueInCM: event.target.value
			}
	    });
  	}

  	middleHandleChange(event) {
    	this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedMiddleMatValueInCM: event.target.value
			}
	    });
  	}

  	bottomHandleChange(event) {
    	this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedBottomMatValueInCM: event.target.value
			}
	    });
  	}

	createMatView = (matTop, matMiddle, matBottom) => {
		let matView = [];
		matView.push(matTop);
		matView.push(matMiddle);
		matView.push(matBottom);
		return matView;
	}

	handleMatsViewChange(size) {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				matView: size
			}
	    });
	}

	render() {
		const {selectedMatSize} = this.props;
		if (parseFloat(selectedMatSize) === 0) {
			return (
				<div className="alert alert-info">Adding mats is easy just choose a mat.</div>
			);
		}
		const selectOptions = this.state.selectValues.map((size, key) => {
			return (
				<option key={key} value={size}>{size+'cm'}</option>
			)
	    })
		const MatOptionTop =
			<div className="col-sm-12 m-b-5" key="topmat">
				<div className="row">
					<div className="col-xs-6">
						<a href="#!" className="selectionArea" onClick={this.handleMatsViewChange.bind(this, 1)}>
							<div className="col-sm-3" style={{backgroundColor: this.props.selectedTopMat.getIn(['acf', 'color'])}}></div>
							<div className="col-sm-9" style={{padding: '5px'}}>
								<span>Top</span>
								{this.props.selectedTopMat.size > 0 ? <span>{this.props.selectedTopMat.getIn(['title', 'rendered'])}</span> : ''}
							</div>
						</a>
					</div>
					<div className="col-xs-6">
						<select className="col-sm-12" value={this.props.selectedTopMatValueInCM} onChange={this.topHandleChange}>
				        	{selectOptions}
				        </select>
					</div>
				</div>
			</div>;
		const MatOptionMiddle =
			<div className="col-sm-12 m-b-5" key="middlemat">
				<div className="row">
					<div className="col-xs-6">
						<a href="#!" className="selectionArea" onClick={this.handleMatsViewChange.bind(this, 2)}>
							<div className="col-sm-3" style={{backgroundColor: this.props.selectedMiddleMat.getIn(['acf', 'color'])}}></div>
							<div className="col-sm-9" style={{padding: '5px'}}>
								<span>Middle</span>
								{this.props.selectedMiddleMat.size > 0 ? <span>{this.props.selectedMiddleMat.getIn(['title', 'rendered'])}</span> : ''}
							</div>
						</a>
					</div>
					<div className="col-xs-6">
						<select className="col-sm-12" value={this.props.selectedMiddleMatValueInCM} onChange={this.middleHandleChange}>
				        	{selectOptions}
				        </select>
					</div>
				</div>
			</div>;
		const MatOptionBottom =
			<div className="col-sm-12 m-b-5" key="bottommat">
				<div className="row">
					<div className="col-xs-6">
						<a href="#!" className="selectionArea" onClick={this.handleMatsViewChange.bind(this, 3)}>
							<div className="col-sm-3" style={{backgroundColor: this.props.selectedBottomMat.getIn(['acf', 'color'])}}></div>
							<div className="col-sm-9" style={{padding: '5px'}}>
								<span>Bottom</span>
								{this.props.selectedBottomMat.size > 0 ? <span>{this.props.selectedBottomMat.getIn(['title', 'rendered'])}</span> : ''}
							</div>
						</a>
					</div>
					<div className="col-xs-6">
						<select className="col-sm-12" value={this.props.selectedBottomMatValueInCM} onChange={this.bottomHandleChange}>
				        	{selectOptions}
				        </select>
					</div>
				</div>
			</div>;

		let MatViewOptions = '';
		if ( parseFloat(selectedMatSize) === 1 ) {
			MatViewOptions = this.createMatView(MatOptionTop, '', '');
		} else if ( parseFloat(selectedMatSize) === 2 ) {
			MatViewOptions = this.createMatView(MatOptionTop, MatOptionMiddle, '');
		} else if ( parseFloat(selectedMatSize) === 3 ) {
			MatViewOptions = this.createMatView(MatOptionTop, MatOptionMiddle, MatOptionBottom);
		}

		return (
			<div className="row">
				{MatViewOptions}
			</div>
		);
	}
}
export default MatViewSelection;